/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMetadata = exports.loadCoordinates = exports.loadCoordinateFailed = exports.loadCoordinate = exports.getDataForCoordinates = exports.getDataForCoordinate = exports.coordinateLoaded = exports.clearCoordinates = exports.clearCoordinate = exports.clearAll = exports.SET_METADATA = exports.LOAD_COORDINATE_FAILED = exports.LOAD_COORDINATES = exports.LOAD_COORDINATE = exports.COORDINATE_LOADED = exports.CLEAR_COORDINATES = exports.CLEAR_COORDINATE = exports.CLEAR_ALL = void 0;
var LOAD_COORDINATE = 'vdk/datagrid/LOAD_COORDINATE';
exports.LOAD_COORDINATE = LOAD_COORDINATE;
var LOAD_COORDINATE_FAILED = 'vdk/datagrid/LOAD_COORDINATE_FAILED';
exports.LOAD_COORDINATE_FAILED = LOAD_COORDINATE_FAILED;
var LOAD_COORDINATES = 'vdk/datagrid/LOAD_COORDINATES';
exports.LOAD_COORDINATES = LOAD_COORDINATES;
var COORDINATE_LOADED = 'vdk/datagrid/COORDINATE_LOADED';
exports.COORDINATE_LOADED = COORDINATE_LOADED;
var CLEAR_COORDINATE = 'vdk/datagrid/CLEAR_COORDINATE';
exports.CLEAR_COORDINATE = CLEAR_COORDINATE;
var CLEAR_COORDINATES = 'vdk/datagrid/CLEAR_COORDINATES';
exports.CLEAR_COORDINATES = CLEAR_COORDINATES;
var CLEAR_ALL = 'vdk/datagrid/CLEAR_ALL';
exports.CLEAR_ALL = CLEAR_ALL;
var SET_METADATA = 'vdk/epg/SET_METADATA';
exports.SET_METADATA = SET_METADATA;
var setMetadata = function setMetadata(metadata, dataId) {
  return {
    type: SET_METADATA,
    payload: {
      metadata: metadata,
      dataId: dataId
    }
  };
};
exports.setMetadata = setMetadata;
var loadCoordinate = function loadCoordinate(coordinate, dataId) {
  return {
    type: LOAD_COORDINATE,
    payload: {
      coordinate: coordinate,
      dataId: dataId
    }
  };
};
exports.loadCoordinate = loadCoordinate;
var coordinateLoaded = function coordinateLoaded(coordinate, data, dataId) {
  return {
    type: COORDINATE_LOADED,
    payload: {
      coordinate: coordinate,
      data: data,
      dataId: dataId
    }
  };
};
exports.coordinateLoaded = coordinateLoaded;
var loadCoordinates = function loadCoordinates() {
  var coordinates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var dataId = arguments.length > 1 ? arguments[1] : undefined;
  return {
    type: LOAD_COORDINATES,
    payload: {
      coordinates: coordinates,
      dataId: dataId
    }
  };
};
exports.loadCoordinates = loadCoordinates;
var loadCoordinateFailed = function loadCoordinateFailed(coordinate, data, dataId) {
  return {
    type: LOAD_COORDINATE_FAILED,
    payload: {
      coordinate: coordinate,
      data: data,
      dataId: dataId
    }
  };
};
exports.loadCoordinateFailed = loadCoordinateFailed;
var clearCoordinate = function clearCoordinate(coordinate, dataId) {
  return {
    type: CLEAR_COORDINATE,
    payload: {
      coordinate: coordinate,
      dataId: dataId
    }
  };
};
exports.clearCoordinate = clearCoordinate;
var clearCoordinates = function clearCoordinates(coordinates, dataId) {
  return {
    type: CLEAR_COORDINATES,
    payload: {
      coordinates: coordinates,
      dataId: dataId
    }
  };
};
exports.clearCoordinates = clearCoordinates;
var clearAll = function clearAll(dataId) {
  return {
    type: CLEAR_ALL,
    payload: {
      dataId: dataId
    }
  };
};
exports.clearAll = clearAll;
var getDataForCoordinate = function getDataForCoordinate(coordinate, onLoadCoordinate, dataId) {
  return function (dispatch) {
    dispatch(loadCoordinate(coordinate, dataId));
    return onLoadCoordinate(coordinate, dataId).then(function (data) {
      dispatch(coordinateLoaded(coordinate, data, dataId));
    })["catch"](function (error) {
      dispatch(loadCoordinateFailed(coordinate, error, dataId));
    });
  };
};
exports.getDataForCoordinate = getDataForCoordinate;
var getDataForCoordinates = function getDataForCoordinates(coordinates, onLoadCoordinate, dataId) {
  return function (dispatch) {
    dispatch(loadCoordinates(coordinates, dataId));
    var loadPromises = coordinates.map(function (coordinate) {
      return onLoadCoordinate(coordinate, dataId).then(function (data) {
        dispatch(coordinateLoaded(coordinate, data, dataId));
      })["catch"](function (error) {
        dispatch(loadCoordinateFailed(coordinate, error, dataId));
      });
    });
    return Promise.all(loadPromises);
  };
};
exports.getDataForCoordinates = getDataForCoordinates;